import PropTypes from 'prop-types';
import styles from '../../styles/main.scss';

import { BasicSelect } from 'dibs-elements/exports/BasicSelect';

const Select = props => {
    const {
        dataTn,
        error,
        isBlurred,
        isClearable,
        disabled,
        searchable,
        name,
        fieldSize,
        onChange,
        onBlur,
        options,
        placeholder,
        value,
        wrapperClass,
        disableAutocomplete,
    } = props;
    const showError = !disabled && isBlurred && !!error;
    return (
        <div className={`${wrapperClass} ${styles.select}`} data-field={name}>
            <BasicSelect
                autoComplete={disableAutocomplete ? 'turn-off-autocomplete' : undefined}
                wrapperClass={styles.select}
                options={options}
                dataTn={dataTn}
                name={name}
                value={value}
                size={fieldSize}
                clearable={isClearable}
                disabled={disabled}
                placeholder={placeholder}
                onChange={e => onChange({ name, value: e.target.value }, onBlur)}
                errorMessage={showError && error}
                searchable={searchable}
                maskForPrivacy
            />
        </div>
    );
};

Select.propTypes = {
    dataTn: PropTypes.string.isRequired,
    error: PropTypes.any,
    isBlurred: PropTypes.bool,
    isClearable: PropTypes.bool,
    disabled: PropTypes.bool,
    searchable: PropTypes.bool,
    name: PropTypes.any.isRequired,
    fieldSize: PropTypes.oneOf(['small', 'medium', 'large']),
    onChange: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(
        PropTypes.shape({
            label: PropTypes.any.isRequired,
            value: PropTypes.any.isRequired,
        })
    ).isRequired,
    placeholder: PropTypes.any,
    value: PropTypes.any.isRequired,
    wrapperClass: PropTypes.string,
    disableAutocomplete: PropTypes.bool,
};

Select.defaultProps = {
    dataTn: '',
    isClearable: false,
    disabled: false,
    searchable: false,
    fieldSize: null,
    placeHolder: '',
    wrapperClass: '',
};

export default Select;
